export default {
  template_id: 'gh_tabs',
  html: function (value, func) {
    let tab_menu = '';
    let tabs = '';
    let mobile_title = '';

    // Tabs can be reordered by drag-and-drop in the editor, which updates their priority
    const sorted_tabs = [...value.content].sort((a, b) => (a.priority || 0) - (b.priority || 0));

    angular.forEach(sorted_tabs, function (item, key) {
      tab_menu += `
        <span class="gh_tabs_block_nav_btn"
            ng-click="this['tab_id' + ${ value.container_id }] = ${ key }; this['tab_detail_open' + ${ value.container_id }] = true;"
            ng-class="{'--active_tab' : this['tab_id' + ${ value.container_id }] == ${ key }}">
          <span class="gh_tabs_block_nav_btn_icon" gh-icon="${ item.icon_id ? item.icon_id : 'box' } a7a9b3 30px normal"></span>
          <span class="gh_tabs_block_nav_btn_title">${ item.name }</span>
          <span class="gh_tabs_block_nav_btn_chevron" gh-icon="arrow_right a7a9b3 22px normal"></span>
        </span>`;

      tabs += `<div ng-if="this['tab_id' + ${ value.container_id }] == ${ key }" class="gh_tabs_block_list_item">${ func(item.content) }</div>`;

      mobile_title += `<span ng-if="this['tab_id' + ${ value.container_id }] == ${ key }">${ item.name }</span>`;
    });

    return `
      <div ng-init="this['tab_id' + ${ value.container_id }] = 0; this['tab_detail_open' + ${ value.container_id }] = false;" class="${ value.class }">
        <div class="gh_tabs_block_track" ng-class="{'--detail_open' : this['tab_detail_open' + ${ value.container_id }]}">
          <div class="gh_tabs_block_nav">
            ${ tab_menu }
          </div>

          <div class="gh_tabs_block_content_pane">
            <div class="gh_tabs_mobile_header" ng-click="this['tab_detail_open' + ${ value.container_id }] = false">
              <span class="gh_tabs_mobile_back">
                <span gh-icon="arrow_left 0893d2 24px normal"></span>
              </span>
              <span class="gh_tabs_mobile_title">${ mobile_title }</span>
            </div>

            <div class="gh_tabs_block_list">
              ${ tabs }
            </div>
          </div>
        </div>
      </div>`;
  }
};
